<template>
  <HeaderContent title="Maintenance Issue" />
  <ActionContent
    ctaText="Add Maintenance Issue"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <MaintenanceIssueStatistics
    title="Maintenance Issue Statistics"
    :data="statistics"
  />
  <MaintenanceIssueForm
    :modal="modal"
    :maintenanceIssueData="maintenanceIssue"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <MaintenanceIssueConfirm
    title="Confirmation"
    :uuid="maintenanceIssueUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(maintenanceIssueUuid)"
  >
    <template #text>Are you sure to delete this data ?</template>
  </MaintenanceIssueConfirm>
  <MaintenanceIssueDataTable
    :data="maintenanceIssues"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import MaintenanceIssueForm from "./MaintenanceIssueForm.vue";
import MaintenanceIssueDataTable from "@/components/DataTable.vue";
import MaintenanceIssueStatistics from "@/components/StatisticData.vue";
import MaintenanceIssueConfirm from "@/components/ModalDialog.vue";
import iconIssueLoupe from "../../../public/icons/issue-loupe.svg";
import { ref, inject, onMounted } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    MaintenanceIssueForm,
    MaintenanceIssueDataTable,
    MaintenanceIssueStatistics,
    MaintenanceIssueConfirm,
  },
  setup() {
    const repositories = inject("repositories");
    const maintenanceIssueRepository = repositories
      ? repositories.maintenanceIssue
      : null;
    const modal = ref(false);
    const modalConfirm = ref(false);
    const maintenanceIssueUuid = ref(null);
    const maintenanceIssue = ref({});
    const maintenanceIssues = ref([]);

    const headers = ref([
      {
        key: "no",
        label: "No",
        class: "text-left",
      },
      {
        key: "name",
        label: "Name",
        sortable: true,
        class: "text-left",
      },
      {
        key: "description",
        label: "Description",
        sortable: true,
        class: "text-left",
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const statistics = ref([]);

    const getAll = async () => {
      await maintenanceIssueRepository
        .getAll()
        .then((res) => {
          maintenanceIssues.value = res.data.data;
          statistics.value = [
            {
              label: "Total",
              key: "Maintenance Issue",
              value: res.data.data.length,
              color: "primary",
              icon: iconIssueLoupe,
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getById = async (uuid) => {
      await maintenanceIssueRepository
        .getById(uuid)
        .then((res) => {
          maintenanceIssue.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      maintenanceIssue.value = {};
    };

    const showModal = () => {
      modal.value = true;
    };

    const showConfirmModal = (uuid) => {
      maintenanceIssueUuid.value = uuid;
      modalConfirm.value = true;
    };

    const deleteData = async (uuid) => {
      await maintenanceIssueRepository
        .delete(uuid)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const searchData = async (keyword) => {
      await maintenanceIssueRepository
        .search(keyword)
        .then((res) => {
          maintenanceIssues.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      maintenanceIssueUuid,
      maintenanceIssue,
      maintenanceIssues,
      headers,
      customActions,
      statistics,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      getAll,
      getById,
      searchData,
    };
  },
};
</script>
